function TicketConversation({ ticket }) {

    return (

        <div className="ticket-conversation">

            <h3>Conversation</h3>

            {ticket.conversation?.map((message) => (

                <div
                    key={message._id}
                    className={`message ${message.senderType}`}
                >

                    <div className="message-header">

                        <strong>

                            {message.senderName}

                        </strong>

                    </div>

                    <p>{message.message}</p>

                    <small>

                        {new Date(
                            message.createdAt
                        ).toLocaleString()}

                    </small>

                </div>

            ))}

        </div>

    );

}

export default TicketConversation;